var React = require('react');

function IconPurpleCircleTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.5 40.9188L34.5438 49.375L52.5 32.1875M65 40C65 44.9445 63.5338 49.778 60.7867 53.8893C58.0397 58.0005 54.1352 61.2048 49.5671 63.097C44.9989 64.9892 39.9723 65.4843 35.1228 64.5196C30.2732 63.555 25.8187 61.174 22.3223 57.6777C18.826 54.1814 16.445 49.7268 15.4804 44.8773C14.5157 40.0277 15.0108 35.0011 16.903 30.4329C18.7952 25.8648 21.9995 21.9603 26.1108 19.2133C30.222 16.4662 35.0555 15 40 15C46.6304 15 52.9893 17.6339 57.6777 22.3223C62.3661 27.0107 65 33.3696 65 40Z","stroke":"#5E47B9","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconPurpleCircleTick.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = IconPurpleCircleTick;

IconPurpleCircleTick.default = IconPurpleCircleTick;
